var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H14.449V2.61941H13.3505V3.71787H12.1676V4.90082H11.0691V5.99928H9.97064V7.09774H8.95668V11.3226H7.94271V12.4211H5.5768V11.3226H5.4923V7.09774H4.47834V5.99928H3.37988V4.90082H2.28142V3.71787H1.18296V2.61941H0V0ZM1.26745 1.09846V1.68994H2.36591V2.7039H3.54887V3.80236H4.64733V4.90082H5.74579V6.08378H6.75976V11.3226H7.85822V6.08378H8.87218V4.90082H9.97064V3.80236H11.0691V2.7039H12.2521V1.68994H13.3505V1.09846H1.26745Z",
    fill: "#2D303A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSign);
export default __webpack_public_path__ + "static/media/filter_sign.364b2c74b7734bfb7b22b366c9f3868d.svg";
export { ForwardRef as ReactComponent };